var map = {
	"./arches.css": [
		882,
		882
	],
	"./beach.css": [
		873,
		873
	],
	"./blue.css": [
		626,
		626
	],
	"./comic.css": [
		627,
		627
	],
	"./dark.css": [
		62,
		62
	],
	"./default.css": [
		951,
		951
	],
	"./forest.css": [
		21,
		21
	],
	"./green.css": [
		233,
		233
	],
	"./grey.css": [
		255,
		255
	],
	"./light.css": [
		364,
		364
	],
	"./matrix.css": [
		637,
		637
	],
	"./orange.css": [
		776,
		776
	],
	"./purple.css": [
		528,
		528
	],
	"./red.css": [
		105,
		105
	],
	"./space.css": [
		490,
		490
	],
	"./vibrant.css": [
		290,
		290
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 924;
module.exports = webpackAsyncContext;